/* eslint-disable */
import { VEBYearlyOpenAndCurrentEffectiveDate } from "../../../constants/VEBYearlyOpenAndCurrentDate";
import { VEBPlans } from "../../../types/components/enrollmentProps.types";
import { Member, Relationship } from "../../../types/employee.types";
import { VEBPlanSchema } from "../../../types/VEBPlanSchema";
import { member } from "../../api/member/member";
import calculateAge, {
	// calculateAgeDynamic,
	calculateAgeDynamicV2,
	getAgeInDays,
	getAgeInDaysV2,
	getAgeInDaysWholeLife
} from "../age";

type EligibleDependents = {
	dependents: Member[];
	ineligibleRelationshipDependents: Member[];
	ineligibleDependents: Member[];
	coverage: string[];
};

export const getCoverage = (relationship: Relationship) => {
	if (relationship === "CHILD") {
		return "Employee & Dependents";
	} else if (relationship === "GRAND CHILD") {
		return "Employee & Dependents";
	} else if (relationship === "SPOUSE") {
		return "Employee & Spouse";
	} else if (relationship === "DOMESTIC PARTNER") {
		return "Employee & Spouse";
	} else if (relationship === "STEP CHILD") {
		return "Employee & Dependents";
	} else {
		return "Employee & Family";
	}
};

export const getKemperHospitalIndemnityCoverage = (relationship: Relationship) => {
	if (relationship === "CHILD" || relationship === "STEP CHILD") {
		return "Employee & Children";
	} else if (relationship === "SPOUSE") {
		return "Employee & Spouse";
	} else {
		return "Employee & Family";
	}
};

export const getBeamVisionCoverage = getKemperHospitalIndemnityCoverage;

export const getKemperHospitalEligibleDependents = (dependents: Member[]): EligibleDependents => {
	const coverage: string[] = ["Employee Only"];
	const eligibleDependents: Member[] = [];
	const eligibleRelationships: string[] = ["CHILD", "SPOUSE", "STEP CHILD"];
	const ineligibleRelationshipDependents: Member[] = [];
	const ineligibleDependents: Member[] = [];
	dependents.forEach((dependent: Member) => {
		const { date_of_birth, relationship } = dependent;
		if (relationship !== null && eligibleRelationships.includes(relationship)) {
			const dependentAge = calculateAge(
				date_of_birth,
				VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_YYYYMMDD
			);
			// console.log("dependentAge", dependentAge);
			if (dependentAge <= 25 || relationship === "SPOUSE") {
				const coverageStr = getKemperHospitalIndemnityCoverage(relationship as Relationship);
				coverage.indexOf(coverageStr) === -1 ? coverage.push(coverageStr) : null;
				eligibleDependents.push(dependent);
			} else {
				ineligibleDependents.push(dependent);
			}
		} else {
			ineligibleRelationshipDependents.push(dependent);
		}
	});

	if (
		coverage.indexOf("Employee & Spouse") !== -1 &&
		coverage.indexOf("Employee & Children") !== -1 &&
		coverage.indexOf("Employee & Family") === -1
	) {
		coverage.push("Employee & Family");
	}
	return {
		dependents: eligibleDependents,
		coverage,
		ineligibleDependents,
		ineligibleRelationshipDependents
	};
};

// export const getCommonEligibleDependents = (dependents: Member[], Plan: VEBPlanSchema) => {
// 	const eligibleDependents: Member[] = [];
// 	const ineligibleRelationshipDependents: Member[] = [];
// 	const ineligibleDependents: Member[] = [];

// 	const coverage: string[] = Plan?.coverage_for?.options ?? [];
// 	const eligibleRelationships: string[] = Plan?.dependent_eligibility?.eligible_relationship ?? [];

// 	dependents.forEach((dependent) => {
// 		const { date_of_birth, relationship } = dependent;

// 		//  No relationship
// 		if (!relationship) {
// 			ineligibleRelationshipDependents.push(dependent);
// 			return;
// 		}

// 		//  Relationship not eligible
// 		if (!eligibleRelationships.includes(relationship)) {
// 			ineligibleRelationshipDependents.push(dependent);
// 			return;
// 		}

// 		const dependentAge = calculateAge(
// 			date_of_birth,
// 			VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_YYYYMMDD
// 		);
// 		console.log("dependentAge", dependentAge);

// 		// ---------- SPOUSE ----------
// 		if (relationship === "SPOUSE") {
// 			// Coverage check
// 			if (!coverage.includes("Employee & Spouse")) {
// 				ineligibleDependents.push(dependent);
// 				return;
// 			}

// 			const { min_age, max_age } = Plan.dependent_eligibility.spouse;
// 			console.log("spouse", min_age, max_age, dependentAge);

// 			if (dependentAge >= min_age && dependentAge < max_age) {
// 				eligibleDependents.push(dependent);
// 			} else {
// 				ineligibleDependents.push(dependent);
// 			}
// 			return;
// 		}

// 		// ---------- CHILD / OTHER DEPENDENTS ----------
// 		if (!coverage.includes("Employee & Children")) {
// 			ineligibleDependents.push(dependent);
// 			return;
// 		}

// 		const { min_age, max_age } = Plan.dependent_eligibility.children;
// 		console.log("children", min_age, max_age);

// 		if (dependentAge >= min_age && dependentAge < max_age) {
// 			eligibleDependents.push(dependent);
// 		} else {
// 			ineligibleDependents.push(dependent);
// 		}
// 	});

// 	return {
// 		dependents: eligibleDependents,
// 		coverage,
// 		ineligibleDependents,
// 		ineligibleRelationshipDependents
// 	};
// };
export const getCommonEligibleDependents = (dependents: Member[], Plan: VEBPlanSchema) => {
	const eligibleDependents: Member[] = [];
	const ineligibleRelationshipDependents: Member[] = [];
	const ineligibleDependents: Member[] = [];

	const coverage: string[] = Plan?.coverage_for?.options ?? [];
	const eligibleRelationships: string[] = Plan?.dependent_eligibility?.eligible_relationship ?? [];

	// ── Rider eligibility (merge in if rider is present) ──────────────────
	const riderIsPresent = Plan?.rider?.is_present ?? false;
	const riderCoverage: string[] = riderIsPresent ? Plan?.rider?.coverage_for?.options ?? [] : [];
	const riderDependentEligibility: string[] = riderIsPresent
		? Plan?.rider?.dependent_eligibility?.eligible_relationship ?? []
		: [];

	// Merge rider relationships into eligible relationships if rider is present
	const mergedEligibleRelationships = riderIsPresent
		? [...new Set([...eligibleRelationships, ...riderDependentEligibility])]
		: eligibleRelationships;

	// Merge rider coverage options into coverage if rider is present
	const mergedCoverage = riderIsPresent ? [...new Set([...coverage, ...riderCoverage])] : coverage;

	const maxSpouse = Plan?.dependent_eligibility?.spouse?.max_count ?? 1;
	const maxChildren = Plan?.dependent_eligibility?.children?.max_count ?? Infinity;

	let spouseCount = 0;
	let childrenCount = 0;

	const childRelationships = ["CHILD", "STEP CHILD", "COURT-ORDER-DOCUMENT", "GRANDCHILD"];

	dependents.forEach((dependent) => {
		const { date_of_birth, relationship } = dependent;

		// No relationship
		if (!relationship) {
			ineligibleRelationshipDependents.push(dependent);
			return;
		}

		// No date of birth — treat as ineligible
		if (!date_of_birth) {
			ineligibleDependents.push(dependent);
			return;
		}

		// Relationship not allowed by plan or rider
		if (!mergedEligibleRelationships.includes(relationship)) {
			ineligibleRelationshipDependents.push(dependent);
			return;
		}

		const dependentAge = calculateAgeDynamicV2(
			date_of_birth,
			VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_YYYYMMDD
		);

		if (relationship === "SPOUSE") {
			// Check main plan OR rider coverage includes spouse
			const mainPlanAllowsSpouse =
				coverage.includes("Employee & Spouse") ||
				coverage.includes("Spouse Only") ||
				coverage.includes("Employee & Family");
			const riderAllowsSpouse =
				riderIsPresent &&
				(riderCoverage.includes("Employee & Spouse") ||
					riderCoverage.includes("Spouse Only") ||
					riderCoverage.includes("Employee & Family"));

			if (!mainPlanAllowsSpouse && !riderAllowsSpouse) {
				ineligibleDependents.push(dependent);
				return;
			}

			const { min_age, max_age } = Plan.dependent_eligibility.spouse;

			if (dependentAge >= min_age && dependentAge < max_age && spouseCount < maxSpouse) {
				eligibleDependents.push(dependent);
				spouseCount++;
			} else {
				ineligibleDependents.push(dependent);
			}

			return;
		}

		// if (childRelationships.includes(relationship)) {
		// 	// Check main plan OR rider coverage includes children
		// 	const mainPlanAllowsChildren =
		// 		coverage.includes("Employee & Children") ||
		// 		coverage.includes("Children Only") ||
		// 		coverage.includes("Employee & Family");
		// 	const riderAllowsChildren =
		// 		riderIsPresent &&
		// 		(riderCoverage.includes("Employee & Children") ||
		// 			riderCoverage.includes("Children Only") ||
		// 			coverage.includes("Employee & Family"));

		// 	if (!mainPlanAllowsChildren && !riderAllowsChildren) {
		// 		ineligibleDependents.push(dependent);
		// 		return;
		// 	}

		// 	const { min_age, max_age } = Plan.dependent_eligibility.children;
		// 	if (Plan?.plan_code === "WL-ALL-2026" && Plan?.plan_name === "Whole life") {
		// 		if (getAgeInDaysV2(date_of_birth) >= 14 && dependentAge < max_age) {
		// 			eligibleDependents.push(dependent);
		// 		}
		// 	}

		// 	if (dependent.is_disabled) {
		// 		const { min_age: disMinAge, max_age: disMaxAge } =
		// 			Plan?.dependent_eligibility?.children?.disabled || {};

		// 		console.log("disabled child values", disMinAge, disMaxAge);

		// 		if (
		// 			disMinAge !== undefined &&
		// 			disMaxAge !== undefined &&
		// 			dependentAge >= disMinAge &&
		// 			dependentAge < disMaxAge &&
		// 			childrenCount < maxChildren
		// 		) {
		// 			eligibleDependents.push(dependent);
		// 			childrenCount++;
		// 		} else {
		// 			ineligibleDependents.push(dependent);
		// 		}
		// 	} else {
		// 		if (dependentAge >= min_age && dependentAge < max_age && childrenCount < maxChildren) {
		// 			console.log("eligible child age", dependentAge);
		// 			eligibleDependents.push(dependent);
		// 			childrenCount++;
		// 		} else {
		// 			console.log("ineligible child age", dependentAge);
		// 			ineligibleDependents.push(dependent);
		// 		}
		// 	}

		// 	return;
		// }

		// Fallback safety

		if (childRelationships.includes(relationship)) {
			// Check main plan OR rider coverage includes children
			const mainPlanAllowsChildren =
				coverage.includes("Employee & Children") ||
				coverage.includes("Children Only") ||
				coverage.includes("Employee & Family");
			const riderAllowsChildren =
				riderIsPresent &&
				(riderCoverage.includes("Employee & Children") ||
					riderCoverage.includes("Children Only") ||
					riderCoverage.includes("Employee & Family"));

			if (!mainPlanAllowsChildren && !riderAllowsChildren) {
				ineligibleDependents.push(dependent);
				return;
			}

			const { min_age, max_age } = Plan.dependent_eligibility.children;

			// ── Special case: Whole Life plan uses day-based age check ──
			if (Plan?.plan_code === "WL-ALL-2026") {
				if (dependent.is_disabled) {
					const { min_age: disMinAge, max_age: disMaxAge } =
						Plan?.dependent_eligibility?.children?.disabled || {};

					if (
						disMinAge !== undefined &&
						disMaxAge !== undefined &&
						getAgeInDaysV2(date_of_birth) >= 14 &&
						dependentAge >= disMinAge &&
						dependentAge < disMaxAge
					) {
						eligibleDependents.push(dependent);
						childrenCount++;
					} else {
						ineligibleDependents.push(dependent);
					}
				} else {
					if (getAgeInDaysV2(date_of_birth) >= 14 && dependentAge < max_age) {
						eligibleDependents.push(dependent);
						childrenCount++;
					} else {
						ineligibleDependents.push(dependent);
					}
				}
				return; // ← prevent fall-through into the checks below
			}

			if (dependent.is_disabled) {
				const { min_age: disMinAge, max_age: disMaxAge } =
					Plan?.dependent_eligibility?.children?.disabled || {};

				// console.log("disabled child values", disMinAge, disMaxAge);

				if (
					disMinAge !== undefined &&
					disMaxAge !== undefined &&
					dependentAge >= disMinAge &&
					dependentAge < disMaxAge &&
					childrenCount < maxChildren
				) {
					eligibleDependents.push(dependent);
					childrenCount++;
				} else {
					ineligibleDependents.push(dependent);
				}
			} else {
				if (dependentAge >= min_age && dependentAge < max_age && childrenCount < maxChildren) {
					console.log("eligible child age", dependentAge);
					eligibleDependents.push(dependent);
					childrenCount++;
				} else {
					console.log("ineligible child age", dependentAge);
					ineligibleDependents.push(dependent);
				}
			}

			return;
		}
		ineligibleDependents.push(dependent);
	});

	return {
		dependents: eligibleDependents,
		coverage,
		ineligibleDependents,
		ineligibleRelationshipDependents
	};
};
export const getKemperWholeLifeEligibleDependents = (dependents: Member[]): EligibleDependents => {
	const coverage: string[] = ["Employee Only"];
	const eligibleDependents: Member[] = [];
	const eligibleRelationships: string[] = ["SPOUSE"];
	const ineligibleRelationshipDependents: Member[] = [];
	const ineligibleDependents: Member[] = [];
	dependents.forEach((dependent: Member) => {
		const { date_of_birth, relationship } = dependent;
		if (relationship !== null && eligibleRelationships.includes(relationship)) {
			const dependentAge = calculateAge(
				date_of_birth,
				VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_YYYYMMDD
			);
			// console.log("dependentAge", dependentAge);
			if (dependentAge >= 18 && dependentAge <= 55) {
				const coverageStr = getKemperHospitalIndemnityCoverage(relationship as Relationship);
				coverage.indexOf(coverageStr) === -1 ? coverage.push(coverageStr) : null;
				eligibleDependents.push(dependent);
			} else {
				ineligibleDependents.push(dependent);
			}
		} else {
			ineligibleRelationshipDependents.push(dependent);
		}
	});
	return {
		dependents: eligibleDependents,
		coverage,
		ineligibleDependents,
		ineligibleRelationshipDependents
	};
};

export const getKemperWholeLifeEligibleDependentsV = (dependents: Member[], member: Member): EligibleDependents => {
	const memberAge = calculateAge(
		member?.date_of_birth,
		VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_YYYYMMDD
	);
	const coverage: string[] = memberAge >= 18 && memberAge <= 55 ? ["Employee Only"] : [];
	const eligibleDependents: Member[] = [];
	const eligibleRelationships: string[] = ["CHILD", "SPOUSE", "STEP CHILD"];
	const ineligibleRelationshipDependents: Member[] = [];
	const ineligibleDependents: Member[] = [];

	dependents.forEach((dependent: Member) => {
		const { date_of_birth, relationship } = dependent;

		if (relationship === null || !eligibleRelationships.includes(relationship)) {
			ineligibleRelationshipDependents.push(dependent);
			return;
		}

		const dependentAge = calculateAge(
			date_of_birth,
			VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_YYYYMMDD
		);

		if (relationship === "SPOUSE") {
			if (dependentAge >= 18 && dependentAge <= 55) {
				const coverageStr = getKemperHospitalIndemnityCoverage("SPOUSE" as Relationship);
				if (!coverage.includes(coverageStr)) {
					coverage.push(coverageStr);
				}
				eligibleDependents.push(dependent);
			} else {
				ineligibleDependents.push(dependent);
			}
			return;
		}

		if (relationship === "CHILD" || relationship === "STEP CHILD") {
			if (getAgeInDaysV2(date_of_birth) >= 30 && dependentAge < 26) {
				const coverageStr = getKemperHospitalIndemnityCoverage(relationship as Relationship);
				if (!coverage.includes(coverageStr)) {
					coverage.push(coverageStr);
				}
				eligibleDependents.push(dependent);
			} else {
				ineligibleDependents.push(dependent);
			}
			return;
		}

		ineligibleDependents.push(dependent);
	});

	return {
		dependents: eligibleDependents,
		coverage,
		ineligibleDependents,
		ineligibleRelationshipDependents
	};
};
export const getKemperWholeLifeEligibleDependentsV2 = (dependents: Member[], member: Member): EligibleDependents => {
	const memberAge = calculateAgeDynamicV2(
		member?.date_of_birth,
		VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_YYYYMMDD
	);
	const coverage: string[] = memberAge >= 18 && memberAge <= 55 ? ["Employee Only"] : [];
	const eligibleDependents: Member[] = [];
	const eligibleRelationships: string[] = ["CHILD", "SPOUSE", "STEP CHILD"];
	const ineligibleRelationshipDependents: Member[] = [];
	const ineligibleDependents: Member[] = [];

	dependents.forEach((dependent: Member) => {
		const { date_of_birth, relationship } = dependent;

		if (relationship === null || !eligibleRelationships.includes(relationship)) {
			ineligibleRelationshipDependents.push(dependent);
			return;
		}

		const dependentAge = calculateAgeDynamicV2(
			date_of_birth,
			VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_YYYYMMDD
		);

		if (relationship === "SPOUSE") {
			if (dependentAge >= 18 && dependentAge <= 55) {
				const coverageStr = getKemperHospitalIndemnityCoverage("SPOUSE" as Relationship);
				if (!coverage.includes(coverageStr)) {
					coverage.push(coverageStr);
				}
				eligibleDependents.push(dependent);
			} else {
				ineligibleDependents.push(dependent);
			}
			return;
		}
		// const ageitis = getAgeInDays(date_of_birth);

		// console.log("this is the ageitis", ageitis);

		if (relationship === "CHILD" || relationship === "STEP CHILD") {
			if (getAgeInDaysWholeLife(date_of_birth) >= 14 && dependentAge < 26) {
				console.log("this is working");
				const coverageStr = getKemperHospitalIndemnityCoverage(relationship as Relationship);
				// if (!coverage.includes(coverageStr)) {
				// 	coverage.push(coverageStr);
				// }
				coverage.push("Employee & Children");
				eligibleDependents.push(dependent);
			} else {
				ineligibleDependents.push(dependent);
			}
			return;
		}

		ineligibleDependents.push(dependent);
	});

	return {
		dependents: eligibleDependents,
		coverage,
		ineligibleDependents,
		ineligibleRelationshipDependents
	};
};
export const getFiveStarEligibleDependents = (dependents: Member[], member: Member): EligibleDependents => {
	const memberAge = calculateAge(member?.date_of_birth, new Date());
	const coverage: string[] = memberAge >= 18 && memberAge <= 70 ? ["Employee Only"] : [];
	const eligibleDependents: Member[] = [];
	const eligibleRelationships: string[] = ["CHILD", "SPOUSE", "STEP CHILD"];
	let hasSpouse = false;
	let hasChildren = false;
	const ineligibleRelationshipDependents: Member[] = [];
	const ineligibleDependents: Member[] = [];
	dependents.forEach((dependent: Member) => {
		const { date_of_birth, relationship } = dependent;
		if (relationship !== null && eligibleRelationships.includes(relationship)) {
			const dependentAge = calculateAge(
				date_of_birth,
				VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_YYYYMMDD
			);
			if (relationship === "SPOUSE") {
				// console.log("age", dependentAge);
			}
			// console.log("dependentAge", dependentAge);
			if (relationship === "SPOUSE" && dependentAge >= 18 && dependentAge <= 70) {
				hasSpouse = true;
				coverage.push("Employee & Spouse", "Spouse Only");
				eligibleDependents.push(dependent);
			}
			if (relationship === "CHILD" || relationship === "STEP CHILD") {
				if (dependent.is_disabled) {
					if (dependentAge >= 0 && dependentAge < 100) {
						eligibleDependents.push(dependent);
					} else {
						ineligibleDependents.push(dependent);
					}
				} else {
					const isEligibleAge =
						(dependentAge >= 1 && dependentAge < 19) ||
						(dependentAge === 0 && getAgeInDays(date_of_birth) >= 14);

					if (isEligibleAge && dependent.marital_status !== "MARRIED") {
						hasChildren = true;

						if (!coverage.includes("Employee & Children")) {
							coverage.push("Employee & Children");
						}

						eligibleDependents.push(dependent);
					} else {
						ineligibleDependents.push(dependent);
					}
				}
			} else {
				ineligibleDependents.push(dependent);
			}
		} else {
			ineligibleRelationshipDependents.push(dependent);
		}
	});
	if (hasSpouse && hasChildren) {
		coverage.push("Spouse & Children", "Employee & Family");
	}
	// console.log("coverage", coverage);
	return {
		dependents: eligibleDependents,
		coverage,
		ineligibleDependents,
		ineligibleRelationshipDependents
	};
};
export const getFiveStarEligibleDependentsV2 = (dependents: Member[], member: Member): EligibleDependents => {
	const memberAge = calculateAgeDynamicV2(
		member?.date_of_birth,
		VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_YYYYMMDD
	);
	const coverage: string[] = memberAge >= 18 && memberAge <= 70 ? ["Employee Only"] : [];
	const eligibleDependents: Member[] = [];
	const eligibleRelationships: string[] = ["CHILD", "SPOUSE", "STEP CHILD"];
	let hasSpouse = false;
	let hasChildren = false;
	const ineligibleRelationshipDependents: Member[] = [];
	const ineligibleDependents: Member[] = [];

	dependents.forEach((dependent: Member) => {
		const { date_of_birth, relationship } = dependent;

		// No relationship or not in eligible list
		if (relationship === null || !eligibleRelationships.includes(relationship)) {
			ineligibleRelationshipDependents.push(dependent);
			return;
		}

		const dependentAge = calculateAgeDynamicV2(
			date_of_birth,
			VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_YYYYMMDD
		);

		if (relationship === "SPOUSE") {
			if (dependentAge >= 18 && dependentAge <= 70) {
				hasSpouse = true;
				if (!coverage.includes("Employee & Spouse")) {
					coverage.push("Employee & Spouse", "Spouse Only"); // ← no duplicates
				}
				eligibleDependents.push(dependent);
			} else {
				ineligibleDependents.push(dependent); // ← out-of-range spouse caught
			}
			return;
		}
		// const ageitis = getAgeInDays(date_of_birth);
		// console.log("this is the ageitis", ageitis);
		if (relationship === "CHILD" || relationship === "STEP CHILD") {
			//  HANDLE DISABLED CHILD (STATIC RULE)
			if (dependent.is_disabled) {
				if (dependentAge >= 0 && dependentAge <= 100) {
					hasChildren = true;

					if (!coverage.includes("Employee & Children")) {
						coverage.push("Employee & Children");
					}

					eligibleDependents.push(dependent);
				} else {
					ineligibleDependents.push(dependent);
				}

				return;
			}

			//  NORMAL CHILD LOGIC
			if (
				((dependentAge >= 1 && dependentAge < 19) ||
					(getAgeInDaysWholeLife(date_of_birth) >= 14 && dependentAge < 19)) &&
				dependent.marital_status !== "MARRIED"
			) {
				hasChildren = true;

				if (!coverage.includes("Employee & Children")) {
					coverage.push("Employee & Children");
				}

				eligibleDependents.push(dependent);
			} else {
				ineligibleDependents.push(dependent);
			}

			return;
		}

		// Fallback safety
		ineligibleDependents.push(dependent);
	});

	if (hasSpouse && hasChildren) {
		coverage.push("Spouse & Children", "Employee & Family");
	}

	return {
		dependents: eligibleDependents,
		coverage,
		ineligibleDependents,
		ineligibleRelationshipDependents
	};
};

export const getKemperCancerEligibleDependents = getKemperHospitalEligibleDependents;
export const getDocAndRxDependents = getKemperHospitalEligibleDependents;
export const getBeamVisionEligibleDependents = getKemperHospitalEligibleDependents;
export const getMaxCareDentailEligibleDependents = getKemperHospitalEligibleDependents;
export const getKemperCriticalIllnessEligibleDependents = getKemperHospitalEligibleDependents;
export const getKemperAccidentEligibleDependents = getKemperHospitalEligibleDependents;
export const getBeazelyGroupLifeEligibleDependents = getKemperHospitalEligibleDependents;
